import api from '../../plugins/api';

// origin — происхождение авто на весь импорт: в Битриксе такого поля нет вообще.
// Не передали — строки уедут в ручную правку, как при загрузке битриксовского Excel
const startBitrixImport = (marks, origin) =>
  api.post('/api/crm/cars/bitrixStock/start', { marks, origin });

export default startBitrixImport;
